// 3D Pinball for Windows — Space Cadet, actually playable: the open-source decompilation's WASM build
// (k4zmu2a/SpaceCadetPinball, hosted by alula) embedded inside an XP window. Keys: Z / / = flippers,
// Space = plunger, X = tilt. Nothing here is ours except the frame; the table is the 1995 original.
import React, { useState } from 'react';
import styled from 'styled-components';

import { WindowDropDowns } from 'components';

const TABLE_URL = 'https://pinball.alula.me/';

const menus = {
  Game: [
    { type: 'item', text: 'New Game', hotkey: 'F2' },
    { type: 'item', text: 'Launch Ball', hotkey: 'Space', disable: true },
    { type: 'item', text: 'Pause / Resume', hotkey: 'F3', disable: true },
    { type: 'separator' },
    { type: 'item', text: 'Open in new window' },
    { type: 'separator' },
    { type: 'item', text: 'Exit' },
  ],
  Options: [
    { type: 'item', text: 'Full Screen', hotkey: 'F4' },
    { type: 'item', text: 'Player Controls...', disable: true },
    { type: 'separator' },
    { type: 'item', text: 'Sounds', symbol: 'check', disable: true },
    { type: 'item', text: 'Music', symbol: 'check', disable: true },
  ],
  Help: [
    { type: 'item', text: 'Help Topics', disable: true },
    { type: 'item', text: 'About Pinball' },
  ],
};

function Pinball({ onClose }) {
  const [nonce, setNonce] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [about, setAbout] = useState(false);

  function onClickOptionItem(item) {
    switch (item) {
      case 'Exit':
        onClose();
        break;
      case 'New Game':
        setLoaded(false);
        setNonce(n => n + 1);
        break;
      case 'Open in new window':
        window.open(TABLE_URL, '_blank', 'noopener');
        break;
      case 'Full Screen': {
        const f = document.getElementById('ic-pinball-frame');
        if (f && f.requestFullscreen) f.requestFullscreen();
        break;
      }
      case 'About Pinball':
        setAbout(a => !a);
        break;
      default:
    }
  }

  return (
    <Div>
      <section className="pb__toolbar">
        <WindowDropDowns items={menus} onClickItem={onClickOptionItem} />
      </section>
      <div className="pb__table">
        {!loaded && (
          <div className="pb__loading">
            <div className="pb__loading__title">3D Pinball for Windows</div>
            <div className="pb__loading__sub">Space Cadet · loading table…</div>
            <div className="pb__loading__bar"><i /></div>
            <div className="pb__loading__hint">
              Z and / flip · Space launches · X tilts. If the table stays black,{' '}
              <a href={TABLE_URL} target="_blank" rel="noreferrer">
                open it in a new window
              </a>
              .
            </div>
          </div>
        )}
        <iframe
          id="ic-pinball-frame"
          key={nonce}
          title="3D Pinball for Windows - Space Cadet"
          src={TABLE_URL}
          allow="fullscreen; autoplay"
          onLoad={() => setLoaded(true)}
          className={loaded ? 'pb__frame pb__frame--on' : 'pb__frame'}
        />
        {about && (
          <div className="pb__about" onClick={() => setAbout(false)}>
            <div className="pb__about__box">
              <b>3D Pinball for Windows - Space Cadet</b>
              <p>Maxis / Cinematronics, 1995. Shipped with Windows XP.</p>
              <p>Running here from the open-source decompilation (k4zmu2a/SpaceCadetPinball), WebAssembly build hosted at pinball.alula.me.</p>
              <p>the internet keeps the ball in play. (real)</p>
              <span className="pb__about__ok">OK</span>
            </div>
          </div>
        )}
      </div>
      <div className="pb__status">
        <div className="pb__status__cell">Player 1</div>
        <div className="pb__status__cell pb__status__cell--grow">Click the table first, then Space to launch</div>
        <div className="pb__status__cell">Ball 1</div>
      </div>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ece9d8;
  .pb__toolbar {
    height: 22px;
    flex-shrink: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    padding-left: 2px;
  }
  .pb__table {
    flex: 1;
    min-height: 0;
    position: relative;
    background: #000;
  }
  .pb__frame {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
    opacity: 0;
    transition: opacity 0.4s;
  }
  .pb__frame--on {
    opacity: 1;
  }
  .pb__loading {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #ccff00;
    font-family: Tahoma, 'Noto Sans', sans-serif;
    font-size: 11px;
    text-align: center;
    padding: 20px;
  }
  .pb__loading__title {
    font-size: 18px;
    font-weight: 700;
    color: #fff;
    text-shadow: 0 0 14px rgba(204, 255, 0, 0.7);
  }
  .pb__loading__sub {
    color: #b8d73c;
  }
  .pb__loading__bar {
    width: 220px;
    height: 14px;
    border: 1px solid #7a9a00;
    background: #111;
    padding: 2px;
    i {
      display: block;
      height: 100%;
      width: 40%;
      background: repeating-linear-gradient(90deg, #ccff00 0 8px, transparent 8px 11px);
      animation: pb-slide 1.2s linear infinite;
    }
  }
  @keyframes pb-slide {
    from { transform: translateX(-40%); }
    to { transform: translateX(250%); }
  }
  .pb__loading__hint {
    color: #9aa860;
    max-width: 320px;
    a {
      color: #ccff00;
    }
  }
  .pb__about {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .pb__about__box {
    background: #ece9d8;
    border: 1px solid #0a246a;
    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.4);
    padding: 14px 18px;
    width: 300px;
    font-size: 11px;
    color: #000;
    p {
      margin: 6px 0;
    }
  }
  .pb__about__ok {
    display: inline-block;
    margin-top: 6px;
    padding: 2px 18px;
    border: 1px solid #003c74;
    border-radius: 3px;
    background: linear-gradient(#fff, #ecebe5);
  }
  .pb__status {
    flex-shrink: 0;
    height: 20px;
    display: flex;
    font-size: 11px;
    border-top: 1px solid rgba(0, 0, 0, 0.2);
  }
  .pb__status__cell {
    padding: 0 8px;
    display: flex;
    align-items: center;
    border-right: 1px solid rgba(0, 0, 0, 0.15);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &--grow {
      flex: 1;
    }
    &:last-child {
      border-right: 0;
    }
  }
`;

export default Pinball;
